// Stale-bundle detection.
//
// The running bundle knows its own identity (REACT_APP_BUILD_ID, baked at
// build time). It cannot know what the CURRENT build is, so it fetches
// /version.json — written by scripts/write-version.js — and compares.
//
// Aug 2026, after a creator's desktop sat on a bundle predating the
// plan-lock removal: it still rendered UPGRADE pills on features that were
// already free on their plan. The origin sends no Cache-Control on the SPA
// shell, so browsers heuristically cache it and may not revalidate for
// hours. nginx + hashed assets fix the next navigation; this is the only
// thing that helps a tab that has been open for days.
//
// DESIGN RULES
//   * NEVER auto-reload. Discarding a half-configured automation would be a
//     worse bug than the one this fixes. The user chooses when.
//   * Fail silent. A failed fetch means "we don't know", never "stale" —
//     a false stale prompt trains people to ignore the real one.
//   * cache: "no-store" on the fetch, belt-and-braces with the server
//     header. A cached version.json cannot detect a cached bundle.

const VERSION_URL = "/version.json";

// 15 minutes. Long enough to be invisible in the network panel, short
// enough that someone who leaves a tab open over lunch is told before they
// spend an afternoon configuring against a stale UI.
export const CHECK_INTERVAL_MS = 15 * 60 * 1000;

/** The identity compiled into THIS bundle. */
export function buildId() {
  return process.env.REACT_APP_BUILD_ID || null;
}

/**
 * Fetch the currently deployed build id.
 * Returns null on any failure — unknown is not stale.
 */
export async function fetchCurrentBuildId() {
  try {
    const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
      cache: "no-store",
      credentials: "omit",
    });
    if (!res.ok) return null;
    const data = await res.json();
    const id = data && data.build;
    return typeof id === "string" && id ? id : null;
  } catch {
    return null;
  }
}

/**
 * Is this bundle superseded?
 *
 * Both values must be known AND different. Any unknown returns false, so a
 * dev build (no REACT_APP_BUILD_ID), a missing version.json, or an offline
 * moment can never produce a prompt.
 */
export function isStale(mine, current) {
  if (!mine || !current) return false;
  return mine !== current;
}
